module.exports = "https://img.xiyuyouxi.com/saas/img/Payment_icon2.dd47a908.png";